import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.scss';
import Container from 'components/templates/_old/Container/Container';
import Login from './pages/Login';
import Board from './pages/Board';
import { createBrowserRouter, Navigate, RouterProvider, useLocation } from 'react-router-dom';
import Map from './pages/Map';
import Confirm from './components/templates/Confirm';
import { useRecoilState } from 'recoil';
import { confirmState } from './store/Atoms';
import useSessionStorage from './hooks/useSessionStorage';
import Admin from './pages/Admin';
import { initGA, sendPageView } from './analytics';
import KakaoRedirect from 'pages/KakaoRedirect';

function App() {
  const { value } = useSessionStorage('role');
  const [confirm, setConfirm] = useRecoilState(confirmState);
  const userRouter = [
    {
      path: '/',
      element: <Container />,
    },
    {
      path: 'login',
      element: <Login />,
    },
    {
      path: 'auth/kakao/callback',
      element: <KakaoRedirect />,
    },
    {
      path: 'board',
      element: <Board category={'COMMON'} />,
    },
    {
      path: 'help',
      element: <Board category={'HELP'} />,
    },
  ];
  const adminRouter = [
    ...userRouter,
    {
      path: 'admin',
      element: <Admin />,
    },
  ];

  const router = createBrowserRouter(value === 'ADMIN' ? adminRouter : userRouter);

  return (
    <>
      <RouterProvider router={router} />
      {!!confirm.text && <Confirm text={confirm.text} cancelFunc={confirm.cancelFunc} submitFunc={confirm.submitFunc} />}
    </>
  );
}

export default App;
